export const PREDICTIONS_PATH = "/pronostics";
export const PREDICTIONS_MATCHES_PATH = `${PREDICTIONS_PATH}/matchs`;
export const PREDICTIONS_LEADERBOARD_PATH = `${PREDICTIONS_PATH}/classement`;
export const PREDICTIONS_STATS_PATH = `${PREDICTIONS_PATH}/stats`;
export const PREDICTIONS_SETTINGS_PATH = `${PREDICTIONS_PATH}/reglages`;
export const PREDICTIONS_REGLEMENT_PATH = `${PREDICTIONS_PATH}/reglement`;
export const PREDICTIONS_LOTS_PATH = `${PREDICTIONS_PATH}/lots`;
export const PREDICTIONS_COMPETITION_DETAIL_PATH = `${PREDICTIONS_PATH}/:competitionId`;
export const PREDICTIONS_PARTICIPANT_PATH = `${PREDICTIONS_PATH}/:competitionId/participants/:userId`;

export const getPredictionsCompetitionDetailPath = (competitionId: string): string =>
  PREDICTIONS_COMPETITION_DETAIL_PATH.replace(":competitionId", competitionId);

export const getPredictionsParticipantPath = (
  competitionId: string,
  userId: string,
): string => PREDICTIONS_PARTICIPANT_PATH
  .replace(":competitionId", competitionId)
  .replace(":userId", userId);
